import React from 'react';
import Tooltip from '../../../../Components/Popup/Tooltip';
import FormattedDate from '../../../../Components/FormattedDate';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	csszResult: {
		result: any;
		checkedAt: string;
	};
	vzpResult: {
		result: any;
		checkedAt: string;
	};
}

const EArchiveListItemVerificationBadge: React.FC<Props> = ({
	csszResult,
	vzpResult,
}) => {
	const { t } = useTranslation();

	let icon = '/dist/icons/v2/badge-check.svg';

	if (
		csszResult?.result &&
		csszResult?.checkedAt &&
		vzpResult?.result &&
		vzpResult?.checkedAt
	) {
		icon = '/dist/icons/v2/badge-doublecheck.svg';
	}

	if (
		(csszResult?.result && csszResult?.checkedAt) ||
		(vzpResult?.result && vzpResult?.checkedAt)
	) {
		return (
			<Tooltip
				trigger={
					<div>
						<img src={icon} alt='check' />
					</div>
				}>
				{csszResult?.result && csszResult?.checkedAt && (
					<div>
						<FormattedDate date={csszResult.checkedAt} /> —{' '}
						{t('component.eArchiveListItemVerificationBadge.csszResult')}
					</div>
				)}
				{vzpResult?.result && vzpResult?.checkedAt && (
					<div>
						<FormattedDate date={vzpResult.checkedAt} /> —{' '}
						{t('component.eArchiveListItemVerificationBadge.vzpResult')}
					</div>
				)}
			</Tooltip>
		);
	}

	return <></>;
};

export default EArchiveListItemVerificationBadge;
